import Axios from "axios";

export class SearchApiOptions {
    rows: number = 10;
    start: number = 0;
}

export class ProductResult {
    description: string;
    
    constructor(description: string) {
        this.description = description;
    }
}

export class SearchResults<T> {
    results: T[];
    totalResults: number;
    start: number;
    count: number;
    
    constructor(totalResults: number, start: number, count: number, results: T[]) {
        this.totalResults = totalResults;
        this.start = start;
        this.count = count;
        this.results = results;
    }
}

export class ProductSearchResults extends SearchResults<ProductResult> {}

export class ProductsApi {
    url: string;
    options: SearchApiOptions;

    constructor(url: string, options?: SearchApiOptions) {
        this.url = url;
        this.options = options != undefined ? options : new SearchApiOptions();

    }
    
    async getProducts() : Promise<Object> {
        return await Axios.get(this.url + "/products")
            .then(response => {
                // console.log("getProducts :)");
                return response.data;
            })
            .catch(error => {
                console.log("getProducts failed => " + error);
            });
    }

    async search(
        context: string,
        borrowingAmount: number,
        propertyValue: number,
        term: number,
        start?: number,
        take?: number,
        sortBy?: object,
        filters?: any,
        options?: any)
        : Promise<ProductSearchResults>
    {
        const features:string[] = [];
        if (filters != null) {
            const keys: string[] = ["lenderFeatures", "advancedFeatures"];
            keys.forEach(k => {
                if (filters[k] != null && Array.isArray(filters[k]) && filters[k].length > 0) {
                    filters[k].forEach((v: string) => {
                       features.push(v);
                    });
                }
            });
        }
        const postData:any = {
            "context": context,
            "borrowingAmount": borrowingAmount,
            "propertyValue": propertyValue,
            "termYears": term,
            "currentMonthly": options != null ? options["currentMonthly"] : null,
            "features": features,
            "parameters": {
                "rows": take === null ? 10 : take,
                "start": start === null ? 0 : start,
                "facets": [ "lender" ],
                "permaFacets": [ "lenderIsBank", "ltvMaxPercent", "initialPeriodDuration" ],
                "facetQueries": {},
                "sort": sortBy
            }
        };
        if (filters["initialPeriod"] != null) {
            postData["query"] = "initialPeriodDuration:" + filters["initialPeriod"];
        }
        if (filters["lender"] != null) {
            postData["parameters"]["facetQueries"]["lender"] = filters["lender"];
        }
        if (filters["ltv"] != null) {
            postData["parameters"]["facetQueries"]["ltvMaxPercent"] = filters["ltv"];
        }
        
        // console.log(this.url + '/products/search ' + JSON.stringify(postData));
        return await Axios.post(this.url + "/products/search", postData)
            .then(response => {
                let results = Object.create(ProductSearchResults.prototype);
                results = Object.assign(results, response.data);

                return results;
            })
            .catch(error => {
                console.log("getProducts failed => " + error);

                throw error;
            });
    }
}
